import React from 'react';

interface TableHeaderProps {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <div className={`flex items-center space-x-2 ${className || ''}`}>
      <span className="font-medium">{title}</span>
      {children && <div onClick={(e) => e.stopPropagation()}>{children}</div>}
    </div>
  );
};
